// src/Services/fetchVentas.js
import { ApiRequestInterceptorQS } from "./apiRequestQS";
import { VENTAS } from "../Constants/Endpoinst";

const ENDPOINT = `${VENTAS.ventas}`;

// Llamada genérica
const callVentasApi = (solicitud, body) => {
    return ApiRequestInterceptorQS(ENDPOINT, "POST", { solicitud, ...body });
};

// 🧾 VENTAS
export const getVentasMensuales = async (anio, gId = 0, eId = 0) =>
    callVentasApi("ventasTotalesMensuales", { anio, gId, eId });

export const getAcumuladoVentas = async (anio, gId = 0, eId = 0) =>
    callVentasApi("acumuladoTotalVentas", { anio, gId, eId });

export const getPeriodosVentas = async (anio, numMes1, numMes2, gId = 0, eId = 0) =>
    callVentasApi("periodoMesesVentas", { anio, numMes1, numMes2, gId, eId });

// 👥 VENDEDORES
export const getVendedores = async () =>
    callVentasApi("vendedores", {});

// 📦 PRODUCTOS
export const getProductosMensuales = async (anio, gId = 0, eId = 0) =>
    callVentasApi("productosVendidos", { anio, gId, eId });

export const getAcumuladoProductos = async (anio, gId = 0, eId = 0) =>
    callVentasApi("acumuladoTotalProductos", { anio, gId, eId });

export const getPeriodosProductos = async (anio, numMes1, numMes2, gId = 0, eId = 0) =>
    callVentasApi("periodoMesesProductos", { anio, numMes1, numMes2, gId, eId });
